import clsx from "clsx";
import { ComponentPropsWithoutRef, ReactElement } from "react";

export const DialogBody = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"div">): ReactElement => (
  <div {...props} className={clsx(className, "mt-6")} />
);
